const skillSets = [
  "Rust",
  "Solana",
  "Solidity",
  "Ethereum",
  "Bitcoin",
  "React.js",
  "Next.js",
  "Angular",
  "Vue.js",
  "Node.js",
  "Nest.js",
  "Python",
  "OpenAI",
  "ML/AI",
  "PostgreSQL",
  "Redis",
  "Firebase",
  "MongoDB",
  "MySQL",
  "GraphQL",
  "Tensorflow",
  "Docker",
  "Kubernetes",
  "MUI",
  "Tailwind",
  "Bootstrap",
  "Android",
  "IOS",
];

const knowledgeSets = [
  "Devops",
  "Github",
  "Gitlab",
  "CI/CD Pipleline",
  "Design",
  "AWS",
  "Azure",
  "Agile methodology"
];

export { skillSets, knowledgeSets };
